import revive_payload_client_4sVQNw7RlN from "/__w/landing-page/landing-page/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/__w/landing-page/landing-page/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/__w/landing-page/landing-page/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/__w/landing-page/landing-page/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/__w/landing-page/landing-page/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/__w/landing-page/landing-page/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/__w/landing-page/landing-page/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/__w/landing-page/landing-page/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/__w/landing-page/landing-page/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_UYiXMU8ZyN from "/__w/landing-page/landing-page/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import apollo_client_W5VimTV2fJ from "/__w/landing-page/landing-page/plugins/apollo-client.js";
import common_components_do797zPtCk from "/__w/landing-page/landing-page/plugins/common-components.js";
import dayjs_FoMn5Zigri from "/__w/landing-page/landing-page/plugins/dayjs.js";
import element_plus_elM4AXquKi from "/__w/landing-page/landing-page/plugins/element-plus.js";
import error_notification_FF7BOyH8zx from "/__w/landing-page/landing-page/plugins/error-notification.js";
import event_bus_JNcXIfrhYt from "/__w/landing-page/landing-page/plugins/event-bus.js";
import firebase_Tc1lVUbp7M from "/__w/landing-page/landing-page/plugins/firebase.js";
import google_maps_isOUeleMUR from "/__w/landing-page/landing-page/plugins/google-maps.js";
import i18n_sVHQBgnb3t from "/__w/landing-page/landing-page/plugins/i18n.js";
import sentry_PZVGm6LH3G from "/__w/landing-page/landing-page/plugins/sentry.js";
import success_notification_wwqWDNZ25g from "/__w/landing-page/landing-page/plugins/success-notification.js";
import t_injector_M9LFG8RMFP from "/__w/landing-page/landing-page/plugins/t-injector.js";
import vue_apple_login_t4H57VMhxS from "/__w/landing-page/landing-page/plugins/vue-apple-login.js";
import vue_cookies_RVVac5KJy2 from "/__w/landing-page/landing-page/plugins/vue-cookies.js";
import vue_facebook_login_8zsQURjR1L from "/__w/landing-page/landing-page/plugins/vue-facebook-login.js";
import vue_google_login_WYxqbhB9mr from "/__w/landing-page/landing-page/plugins/vue-google-login.js";
import vue3_social_sharing_6IgRMgbtAO from "/__w/landing-page/landing-page/plugins/vue3-social-sharing.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_UYiXMU8ZyN,
  apollo_client_W5VimTV2fJ,
  common_components_do797zPtCk,
  dayjs_FoMn5Zigri,
  element_plus_elM4AXquKi,
  error_notification_FF7BOyH8zx,
  event_bus_JNcXIfrhYt,
  firebase_Tc1lVUbp7M,
  google_maps_isOUeleMUR,
  i18n_sVHQBgnb3t,
  sentry_PZVGm6LH3G,
  success_notification_wwqWDNZ25g,
  t_injector_M9LFG8RMFP,
  vue_apple_login_t4H57VMhxS,
  vue_cookies_RVVac5KJy2,
  vue_facebook_login_8zsQURjR1L,
  vue_google_login_WYxqbhB9mr,
  vue3_social_sharing_6IgRMgbtAO
]